var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentSuccess = function SvgPaymentSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.834 32.583v-15.26c0-2.241 0-3.362-.55-4.517-.314-.66-1.029-1.556-1.6-2.009-1.004-.794-1.842-.986-3.517-1.37-2.606-.596-5.48-.927-8.5-.927-5.432 0-10.391 1.07-14.167 2.833-3.775 1.764-8.735 2.834-14.166 2.834-3.02 0-5.895-.331-8.5-.928-2.72-.623-5.667 1.294-5.667 4.084v30.52c0 2.242 0 3.362.55 4.518.314.659 1.028 1.556 1.6 2.008 1.004.795 1.842.986 3.517 1.37 2.605.597 5.48.928 8.5.928 4.161 0 8.046-.629 11.333-1.715",
    stroke: "url(#paymentSuccess_svg__a)",
    strokeWidth: 4.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.167 53.833s2.833 0 5.667 5.667c0 0 9-14.167 17-17",
    stroke: "url(#paymentSuccess_svg__b)",
    strokeWidth: 4.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.584 32.583a7.083 7.083 0 1 1-14.167 0 7.083 7.083 0 0 1 14.167 0Z",
    stroke: "url(#paymentSuccess_svg__c)",
    strokeWidth: 4.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.083 35.415v.026",
    stroke: "url(#paymentSuccess_svg__d)",
    strokeWidth: 5.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.917 29.729v.026",
    stroke: "url(#paymentSuccess_svg__e)",
    strokeWidth: 5.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paymentSuccess_svg__a",
    x1: 34.5,
    y1: 8.5,
    x2: 66.181,
    y2: 35.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7463",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paymentSuccess_svg__b",
    x1: 51.5,
    y1: 42.5,
    x2: 62.815,
    y2: 53.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7463",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paymentSuccess_svg__c",
    x1: 34.5,
    y1: 25.5,
    x2: 43.47,
    y2: 32.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7463",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paymentSuccess_svg__d",
    x1: 16.583,
    y1: 35.415,
    x2: 16.584,
    y2: 35.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7463",
    stopOpacity: 0.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paymentSuccess_svg__e",
    x1: 53.417,
    y1: 29.729,
    x2: 53.418,
    y2: 29.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7463",
    stopOpacity: 0.88
  })))));
};
export default SvgPaymentSuccess;